import FJMobileCreaseEdit from './FJMobileCreaseEdit';
import { useSelector, useDispatch } from 'react-redux';
import FJActionBrushEditCommon from '../../../redux/action/FJActionBrushEditCommon';
import useLocalStore from '../../../hooks/useLocalStore';
import { useCallback } from 'react';
import FJUtil from '../../../util/FJUtil';
import { FJViewCanvasSingleton, MOUSE_EVENT_TYPE } from '../../FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import { useMemo } from 'react';
import { setSliceDisableReset } from '../../../redux/slices/FJSliceBrushEditCommon';

const FJMobileCreaseEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const curBrushType = useSelector(state => state.brushEditCommon.curBrushType);
    const isMouseMove = useSelector(state => state.brushEditCommon.isMouseMove);
    const brashSize = useSelector(state => state.brushEditCommon.brushSize);
    const isSlideCompare = useSelector(state => state.brushEditCommon.isSlideCompare);
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);
    const hasBrushUndo = useSelector(state => state.brushEditCommon.hasBrushUndo);
    const hasBrushRedo = useSelector(state => state.brushEditCommon.hasBrushRedo);
    const _disableReset = useSelector(state => state.brushEditCommon.disableReset);
    const switchScratchOrFold = useSelector(state => state.imageManipulation.switchScratchOrFold);

    const hasUndo = useMemo(() => hasBrushUndo && curBrushType !== MOUSE_EVENT_TYPE.NONE, [hasBrushUndo, curBrushType]);
    const hasRedo = useMemo(() => hasBrushRedo && curBrushType !== MOUSE_EVENT_TYPE.NONE, [hasBrushRedo, curBrushType]);
    const disableReset = useMemo(
        () => _disableReset || curBrushType === MOUSE_EVENT_TYPE.NONE,
        [_disableReset, curBrushType],
    );

    const setBrushSize = useCallback(
        (value, type = 'input') => {
            if (isDisabled) return;

            dispatch(FJActionBrushEditCommon.updateBrushSizeAction(Math.round(value), type));
        },
        [dispatch, isDisabled],
    );

    const changeBrushType = useCallback(
        value => {
            if (isDisabled) return;
            dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(value));
        },
        [dispatch, isDisabled],
    );

    const undoHandler = useCallback(() => {
        const _undoFun = async () => {
            await FJViewCanvasSingleton.undo();
            dispatch(setSliceDisableReset(false));
            dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
        };

        if (hasUndo) {
            _undoFun();
        }
    }, [hasUndo, dispatch]);

    const redoHandler = useCallback(() => {
        const _redoFun = async () => {
            await FJViewCanvasSingleton.redo();
            dispatch(setSliceDisableReset(false));
            dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
        };

        if (hasRedo) {
            _redoFun();
        }
    }, [hasRedo, dispatch]);

    const resetHandler = useCallback(() => {
        if (disableReset) return;
        dispatch(FJActionBrushEditCommon.resetMaskAction());
        dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
    }, [disableReset, dispatch]);
    return (
        <FJMobileCreaseEdit
            disabled={isDisabled}
            brashSize={brashSize}
            curBrushType={curBrushType}
            isMouseMove={isMouseMove}
            isSlideCompare={isSlideCompare}
            hasUndo={hasUndo}
            hasRedo={hasRedo}
            disableReset={disableReset}
            switchScratchOrFold={switchScratchOrFold}
            changeBrushType={changeBrushType}
            changeBrashSize={setBrushSize}
            undoHandler={undoHandler}
            redoHandler={redoHandler}
            resetHandler={resetHandler}
        />
    );
};
export default FJMobileCreaseEditContainer;
